export const cilCaretLeft = ["24 24","<path d='M18.767 23.25h-1.709l-12.558-11.237 12.647-11.248h1.619zM6.753 12.017l10.513 9.407v-18.757z'></path>"]